<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header = "Información de la Provincia">
          <b-form>
            <app-pais
              label="Pais"
              :nombre="paisNombre"
              :lista="paisesList"
              :valido="paisValido"
              :msjInvalido="paisInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="paisActualizado">
            </app-pais>  

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim= "$v.nombre.$model"
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label-for="inactivo"
              :label-cols="labelCols">
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Pais from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, maxLength, numeric, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'provincia/getField',
  mutationType: 'provincia/updateField',
});

export default {
  name: 'ABM',
  components: {
    appPais: Pais,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      paisValido: null,
      paisInvalidoMsj: '',

      paises: [],
      paisesList: [],

      labelCols: 1
    }
  },
  computed: {
    ...mapFields([
      'id',
      'pais',
      'paisNombre',
      'nombre',
      'inactivo',
    ])
  },
  created() {
    let provinciaId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        provinciaId = this.$route.params.id;
      }
    }

    this.getDatosAdicionales();

    this.showSpinner();
    this.$store.dispatch('provincia/inicializar', provinciaId)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          vm.paises = this.$store.getters['paises/paisesSelect']
          vm.paisesList = this.$store.getters['paises/listSelect']
        })
        .catch(() => this.showErrorMsj ('Se produjo un error al recuperar la información de paises'))        
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (this.$v.nombre.$error & !this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }      
          if (this.$v.nombre.$error & !this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del banco';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let pais = null;
      if (this.paisNombre) {
        pais = this.getSelected(this.paises, this.paisNombre);
      }
      this.$store.dispatch('provincia/setPais', pais);

      let paisError = true;
      if (this.pais) {
        if (this.pais.id){
          if (this.pais.id != 0){
            paisError = false;
          }
        }
      }

      if (paisError) {
        this.paisValido = false;
        this.paisInvalidoMsj = "Debe seleccionar el pais correspondiente."
        save = false;
      }

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('provincia/save')
            .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: "Provincias" });
    },
    paisActualizado(paisNombre) {
      this.paisNombre = paisNombre;
    },
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
